// extracted by mini-css-extract-plugin
export default {"buttonUpdateContainer":"ButtonUpdatePassword_buttonUpdateContainer__YZjws","button":"ButtonUpdatePassword_button__UbW1f"};